<!--
 * @Description  : 选择坐席卡片
-->
<template minapp="mpx" xlang="wxml">
  <view class="es-seat-card" wx:if="{{supportChoose || isTransfer}}" wx:class="{{{first: isTransfer && seatIndex === 0, last: isTransfer && seatIndex === 1 }}}">
    <view class="es-seat-card__title">
      <view class="es-seat-card__title-left">{{titleText}}</view>
      <view wx:if="{{max > 1 && supportChoose}}" class="es-seat-card__title-right">可选择{{max}}个座位</view>
      <view wx:elif="{{isTransfer && !supportChoose}}" class="es-seat-card__title-right notsupport">该坐席暂不支持选座</view>
    </view>
   <block wx:if="{{supportChoose}}">
     <view class="es-seat-card__seat-info" wx:for="{{seatList}}" >
      <view class="es-seat-card__seat-text"></view>
      <view class="es-seat-card__container">
        <!-- A坐席 -->
        <image class="es-seat-card__seat-photo" wx:if="{{!item.seat[0].value}}" src="https://dpubstatic.udache.com/static/dpubimg/m0g6C0uyFdxzZrZNwGJ1l.png" bindtap="onSeatClick('A',index)" />
        <block wx:else>
          <view class="es-seat-card__choose-icon"></view>
          <image class="es-seat-card__seat-photo" wx:if="{{isSecondClass}}" src="https://dpubstatic.udache.com/static/dpubimg/3cfuWPUm5EdV6x5Ef_AtM.png" bindtap="onSeatClick('A',index)"/>
          <image class="es-seat-card__seat-photo" wx:elif="{{isFirstClass}}" src="https://dpubstatic.udache.com/static/dpubimg/Mr4i-lAGSYFU9H5mNsAAm.png" bindtap="onSeatClick('A',index)"/>
          <image class="es-seat-card__seat-photo" wx:else src="https://dpubstatic.udache.com/static/dpubimg/hEOqgPHf1zib4mzKzNjU5.png" bindtap="onSeatClick('A',index)"/>
        </block>
      </view>
      
      <!-- B坐席 -->
      <view class="es-seat-card__container" wx:if="{{isSecondClass}}">
        <image class="es-seat-card__seat-photo" wx:if="{{!item.seat[1].value}}" src="https://dpubstatic.udache.com/static/dpubimg/Ox9zp2wefgcWHAOBfZl6J.png" bindtap="onSeatClick('B',index)" />
        <block wx:else>
          <view class="es-seat-card__choose-icon"></view>
          <image class="es-seat-card__seat-photo" src="https://dpubstatic.udache.com/static/dpubimg/bM_Nfzn7iPLlHyDxhJR2T.png" bindtap="onSeatClick('B',index)"/>
        </block>
      </view>
      <image class="es-seat-card__seat-holder" wx:else src="" />
      <!-- C坐席 -->
      <view class="es-seat-card__container">
        <image class="es-seat-card__seat-photo" wx:if="{{!item.seat[2].value}}" src="https://dpubstatic.udache.com/static/dpubimg/LTvJYiTpUdY6TW9ra3RjL.png" bindtap="onSeatClick('C',index)"/>
        <block wx:else>
          <view class="es-seat-card__choose-icon"></view>
          <image class="es-seat-card__seat-photo" wx:if="{{isSecondClass}}" src="https://dpubstatic.udache.com/static/dpubimg/wcUJ3qgD6Dh632U8Bd35Q.png" bindtap="onSeatClick('C',index)"/>
          <image class="es-seat-card__seat-photo" wx:elif="{{isFirstClass}}" src="https://dpubstatic.udache.com/static/dpubimg/johXbmZTzBiwv8xNLN2re.png" bindtap="onSeatClick('C',index)"/>
          <image class="es-seat-card__seat-photo" wx:else src="https://dpubstatic.udache.com/static/dpubimg/mr726MzT8Ik0UveQKbKZ5.png" bindtap="onSeatClick('C',index)"/>
        </block>
      </view>
      <view class="es-seat-card__seat-divider-text"></view>
      <!-- D坐席 -->
      <view class="es-seat-card__container" wx:if="{{isFirstClass || isSecondClass}}">
        <image class="es-seat-card__seat-photo" wx:if="{{!item.seat[3].value}}" src="https://dpubstatic.udache.com/static/dpubimg/FwlEglSQXuSvd5je2MCmY.png" bindtap="onSeatClick('D',index)"/>
        <block wx:else>
          <view class="es-seat-card__choose-icon"></view>
          <image class="es-seat-card__seat-photo" wx:if="{{isSecondClass}}" src="https://dpubstatic.udache.com/static/dpubimg/dB520FoKlqgZmSs_9kmwp.png" bindtap="onSeatClick('D',index)"/>
          <image class="es-seat-card__seat-photo" wx:elif="{{isFirstClass}}" src="https://dpubstatic.udache.com/static/dpubimg/iJPMuGBBLe-6uN40k4lEu.png" bindtap="onSeatClick('D',index)"/>
        </block>
      </view>
      <image class="es-seat-card__seat-holder" wx:else src="" />
      <!-- F坐席 -->
      <view class="es-seat-card__container">
        <image class="es-seat-card__seat-photo" wx:if="{{!item.seat[4].value}}" src="https://dpubstatic.udache.com/static/dpubimg/mGIB1Ki2bldFQmzYdWy3i.png" bindtap="onSeatClick('F',index)"/>
        <block wx:else>
          <view class="es-seat-card__choose-icon"></view>
          <image class="es-seat-card__seat-photo" wx:if="{{isSecondClass}}" src="https://dpubstatic.udache.com/static/dpubimg/ojuCYyC6Yqigj56IadHc-.png" bindtap="onSeatClick('F',index)"/>
          <image class="es-seat-card__seat-photo" wx:elif="{{isFirstClass}}" src="https://dpubstatic.udache.com/static/dpubimg/UJhMM3v3OjFZUtxKriDeX.png" bindtap="onSeatClick('F',index)"/>
          <image class="es-seat-card__seat-photo" wx:else src="https://dpubstatic.udache.com/static/dpubimg/oF5o2y6qXrUpskHPECHF1.png" bindtap="onSeatClick('F',index)"/>
        </block>
      </view>
      <view class="es-seat-card__seat-text"></view>

    </view>

    <view class="es-seat-card__tips" wx:if="{{isMute}}">
      <view class="es-seat-card__tips-row">
        <view class="es-seat-card__content-checkbox" bindtap="silentClick">
        <es-checkbox
          label-position="right"
          custom-class="custom-class"
          name="1"
          value="{{silentSeat}}"
          shap="square"
          icon-style="{{iconStyle}}"
          useIconSlot
          >
            <es-icon
              slot="icon"
              size="8"
              name="check-filled"
            />
        </es-checkbox>
        </view>
        <view>
          <view class="es-seat-card__tips-row" bindtap="showTips">
          <view class="es-seat-card__tips-title">请优先为我分配“静音车厢”席位  </view>
          <es-icon size="14" name="info-circle" color="#1473FF"></es-icon>
          </view>
          <view class="es-seat-card__tips-content">若剩余席位无静音车厢席位，将为您分配其他席位</view>
        </view>
      </view>
    </view>
    <view class="es-seat-card__tips" wx:else>
      <view class="es-seat-card__tips-content">若剩余席位无法满足您的需求，将为您分配其他席位</view>
    </view>
    </block>
  </view>
  </view>
  
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { trackEvent } from '@/common/track'

  createComponent({
    props: {
      seatLength: Number,
      isMute: Boolean,
      max: Number,
      seatIndex: {
        type: Number,
        value: 0
      },
      isTransfer: {
        type: Boolean,
        value: false
      },
      supportChoose: {
        type: Boolean,
        value: false
      }
    },
    data() {
      return {
        silentSeat: false,
        showDialog: false,
        selectSeatType: []
      }
    },
    watch: {
      silentSeat() {
        this.triggerEvent('silent', arguments[0])
        console.log(arguments[0])
      },
      max: {
        immediate: true,
        handler(data) {
          console.log('max 改变')
          this.selectSeatType = []
        }
      }
    },
    methods: {
      onSeatClick(selectedType, index) {
        var select = index + 1 + selectedType
        var cur = [...this.selectSeatType]

        if (cur.includes(select)) {
          cur = cur.filter((item) => item !== select)
        } else {
          if (cur.length === 0 || cur.length < this.max) {
            cur.push(select)
          }
        }
        if (this.max <= 1) {
          cur = []
          cur.push(select)
        }
        this.selectSeatType = cur
        this.seatList?.map((item) => {
          item?.seat?.map((item2) => {
            item2.value = this.selectSeatType?.includes(item2.name)
          })
        })
        this.$forceUpdate()
        trackEvent('user-seat-select', '排查--用户坐席选择', {
         all: JSON.stringify(cur),
         cur: select,
         index: this.seatIndex
        })
        this.triggerEvent('handle', {
          value: cur,
          index: this.seatIndex
        })
      },
      showTips() {
        this.triggerEvent('click')
      },
      silentClick() {
        this.silentSeat = !this.silentSeat
      }
    },
    computed: {
      ...store.mapState({
        selectSeatInfo: 'train.selectSeatInfo',
      }),
      seatList() {
        //[{[0,1,2,3,4,5]},{0,1,2,3,4,5}]
        return this.max > 1
          ? [
              {
                seat: [
                  { name: '1A', value: 0 },
                  { name: '1B', value: 0 },
                  { name: '1C', value: 0 },
                  { name: '1D', value: 0 },
                  { name: '1F', value: 0 }
                ]
              },
              {
                seat: [
                  { name: '2A', value: 0 },
                  { name: '2B', value: 0 },
                  { name: '2C', value: 0 },
                  { name: '2D', value: 0 },
                  { name: '2F', value: 0 }
                ]
              }
            ]
          : [
              {
                seat: [
                  { name: '1A', value: 0 },
                  { name: '1B', value: 0 },
                  { name: '1C', value: 0 },
                  { name: '1D', value: 0 },
                  { name: '1F', value: 0 }
                ]
              }
            ]
      },
      iconStyle() {
        return { borderRadius: '4px' }
      },
      isFirstClass() {
        return this.seatLength === 4
      },
      isSecondClass() {
        return this.seatLength === 5
      },
      titleText() {
        const _titleText = this.isTransfer ? 
          `第${this.seatIndex + 1}程 ${this.selectSeatInfo[this.seatIndex]?.seat_type_name ?? '选择座席'}` 
          : '选择座席'
        return _titleText
      }
    }
  })
</script>
<style scoped lang="stylus" src="./style.styl"></style>
<style lang="stylus" scoped>
.first
  border-radius 8px 8px 0 0
.last 
  padding-top 0 
  border-radius 0 0 8px 8px
.notsupport
  font-family PingFangSC-Regular
  font-size 9px
  font-weight 400
  line-height 16px
  color #999
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'es-checkbox': '@/es-mpx-ui/lib/checkbox',
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-dialog': '@didi/es-mpx-ui/lib/dialog'
    }
  }
</script>